module.exports = __webpack_public_path__ + "static/media/imagePreview.53615c24.svg";